import { IGeneralRedux } from "../../../common/models/response";

export interface IAuthReduxState extends IGeneralRedux {}

export const authState: IAuthReduxState = {
  actionsLoading: false,
  listLoading: false,
  searchLoading: false,
};
